import React from 'react';
import { motion } from 'framer-motion';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import { useTranslation } from '../hooks/useTranslation';
import AGBPageRU from './AGBPageRU';

export default function AGBPage() {
  const { isRussian, currentLanguage } = useTranslation();
  
  // Отладочная информация
  console.log('AGBPage - currentLanguage:', currentLanguage, 'isRussian:', isRussian);
  
  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: { staggerChildren: 0.1, delayChildren: 0.2 },
    },
  };

  const item = {
    hidden: { opacity: 0, y: 20 },
    show: { opacity: 1, y: 0 },
  };

  // Показываем русскую версию если язык русский
  if (isRussian) {
    return <AGBPageRU />;
  }

  return (
    <div className="min-h-screen bg-white text-dark-900">
      <Header />
      <main className="pt-16 sm:pt-20">
        <motion.section
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          className="py-8 sm:py-16 lg:py-20"
        >
          <div className="max-w-4xl mx-auto px-3 sm:px-4 lg:px-8">
            <motion.div variants={item} className="text-center mb-8 sm:mb-12">
              <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold mb-4 sm:mb-6 text-dark-900">
                Allgemeine Geschäftsbedingungen
              </h1>
              <p className="text-sm sm:text-base text-gray-600">
                Alfira Herrmann – Alphavita - Praxis für Coaching & Hypnose
              </p>
              <p className="text-xs sm:text-sm text-gray-500 mt-2">
                (nachfolgend als „Alphavita – Coaching" bezeichnet)
              </p>
            </motion.div>

            <motion.div variants={item} className="prose prose-sm sm:prose-lg max-w-none">
              <div className="bg-gray-50 rounded-xl sm:rounded-2xl p-4 sm:p-6 lg:p-8 mb-6 sm:mb-8">
                <h2 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4 text-dark-900">1. Geltungsbereich</h2>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3 sm:mb-4">
                  Diese Allgemeinen Geschäftsbedingungen (AGB) regeln die Vertragsbeziehungen zwischen Alfira Herrmann (Alphavita – Coaching) und ihren Kunden für sämtliche Coaching-, Trainings- und Beratungsdienstleistungen.
                </p>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3 sm:mb-4">
                  Abweichende oder entgegenstehende Bedingungen des Kunden werden nicht anerkannt, es sei denn, Alfira Herrmann (Alphavita – Coaching) stimmt ihrer Geltung ausdrücklich und schriftlich zu.
                </p>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                  Diese AGB gelten auch dann, wenn Alfira Herrmann (Alphavita – Coaching) in Kenntnis entgegenstehender oder abweichender Bedingungen des Kunden Verträge vorbehaltlos ausführt.
                </p>
              </div>

              <div className="bg-white border border-gray-200 rounded-xl sm:rounded-2xl p-4 sm:p-6 lg:p-8 mb-6 sm:mb-8">
                <h2 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4 text-dark-900">2. Angebote und Honorare</h2>
                
                <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3 text-dark-900">2.1</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3 sm:mb-4">
                  Die Angebote von Alphavita – Coaching sind freibleibend. Änderungen, insbesondere in Bezug auf die Leistungen und Preise, bleiben vorbehalten.
                </p>

                <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3 text-dark-900">2.2</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3 sm:mb-4">
                  Die für die Coaching-Leistungen gültigen Honorare sind auf der Website oder in der individuellen Coaching-Vereinbarung festgelegt.
                </p>

                <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3 text-dark-900">2.3</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3 sm:mb-4">
                  Sofern nicht anders vereinbart, sind alle Honorare in Euro (€) angegeben. Gemäß § 19 UStG wird keine Umsatzsteuer ausgewiesen.
                </p>

                <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3 text-dark-900">2.4</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3 sm:mb-4">
                  Reise- und Übernachtungskosten, Telefongebühren und eventuelle weitere Nebenkosten, die im Zusammenhang mit der Leistungserbringung entstehen, werden dem Kunden zusätzlich in Rechnung gestellt.
                </p>

                <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3 text-dark-900">2.5</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                  Das Honorar ist, sofern nicht anders vereinbart, entweder vor jeder Sitzung per Überweisung oder in bar am Ende jeder Sitzung zu zahlen. Bei Online- und Telefon-Coachings ist das Honorar im Voraus zu überweisen. Der Kunde trägt die Telefonkosten für das Telefoncoaching.
                </p>
              </div>

              <div className="bg-white border border-gray-200 rounded-xl sm:rounded-2xl p-4 sm:p-6 lg:p-8 mb-6 sm:mb-8">
                <h2 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4 text-dark-900">3. Höhere Gewalt und Leistungshindernisse</h2>
                
                <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3 text-dark-900">3.1</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3 sm:mb-4">
                  Bei höherer Gewalt ist Alphavita – Coaching berechtigt, vereinbarte Coachingtermine zu verschieben. Höhere Gewalt liegt auch bei Leistungshindernissen vor, die aufgrund von Krankheit, Unfall oder ähnlichen unvorhersehbaren Umständen entstehen.
                </p>

                <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3 text-dark-900">3.2</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                  In solchen Fällen wird der Kunde unverzüglich von Alphavita – Coaching benachrichtigt und es wird ein Ersatztermin angeboten. Ein Anspruch auf Übernahme von Anfahrts- oder sonstigen Kosten besteht nicht.
                </p>
              </div>

              <div className="bg-white border border-gray-200 rounded-xl sm:rounded-2xl p-4 sm:p-6 lg:p-8 mb-6 sm:mb-8">
                <h2 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4 text-dark-900">4. Widerrufsrecht für Verbraucher</h2>
                
                <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3 text-dark-900">4.1</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3 sm:mb-4">
                  Wenn der Kunde als Verbraucher handelt, hat er das Recht, diesen Vertrag binnen vierzehn Tagen ohne Angabe von Gründen zu widerrufen. Die Widerrufsfrist beträgt vierzehn Tage ab dem Tag des Vertragsabschlusses.
                </p>

                <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3 text-dark-900">4.2</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3 sm:mb-4">
                  Um das Widerrufsrecht auszuüben, muss der Kunde uns (Alfira Herrmann, Hochburger Str. 32, 79312 Emmendingen, E-Mail: alphavita@gmx.de) mittels einer eindeutigen Erklärung (z.B. ein mit der Post versandter Brief oder eine E-Mail) über seinen Entschluss, diesen Vertrag zu widerrufen, informieren.
                </p>

                <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3 text-dark-900">4.3</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3 sm:mb-4">
                  Zur Wahrung der Widerrufsfrist reicht es aus, dass der Kunde die Mitteilung über die Ausübung des Widerrufsrechts vor Ablauf der Widerrufsfrist absendet.
                </p>

                <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3 text-dark-900">4.4</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                  Ausschluss bzw. Erlöschen des Widerrufsrechts: Das Widerrufsrecht erlischt bei einem Vertrag über die Erbringung von Dienstleistungen, wenn die Dienstleistung vollständig erbracht wurde und mit der Ausführung der Dienstleistung erst begonnen wurde, nachdem der Kunde dazu seine ausdrückliche Zustimmung gegeben hat und gleichzeitig seine Kenntnis davon bestätigt hat, dass er sein Widerrufsrecht bei vollständiger Vertragserfüllung durch uns verliert.
                </p>
              </div>

              <div className="bg-white border border-gray-200 rounded-xl sm:rounded-2xl p-4 sm:p-6 lg:p-8 mb-6 sm:mb-8">
                <h2 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4 text-dark-900">5. Copyright und Urheberrecht</h2>
                
                <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3 text-dark-900">5.1</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3 sm:mb-4">
                  Sämtliche dem Kunden ausgehändigten Unterlagen, Konzepte, Skripte und Präsentationsmaterialien unterliegen dem Urheberrecht von Alfira Herrmann (Alphavita – Coaching).
                </p>

                <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3 text-dark-900">5.2</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                  Diese Unterlagen sind ausschließlich für den persönlichen Gebrauch des Kunden bestimmt. Die vollständige oder teilweise Vervielfältigung, Weitergabe an Dritte oder der kommerzielle Gebrauch sind ohne schriftliche Zustimmung von Alfira Herrmann nicht gestattet. Eine Veröffentlichung, auch auszugsweise, ist untersagt und kann rechtliche Schritte nach sich ziehen.
                </p>
              </div>

              <div className="bg-white border border-gray-200 rounded-xl sm:rounded-2xl p-4 sm:p-6 lg:p-8 mb-6 sm:mb-8">
                <h2 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4 text-dark-900">6. Versicherungsschutz und Eigenverantwortung</h2>
                
                <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3 text-dark-900">6.1</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3 sm:mb-4">
                  Bei Seminaren, Workshops oder Teamcoachings, die nicht in den Räumlichkeiten von Alphavita – Coaching stattfinden, ist der jeweilige Auftraggeber der Veranstalter und verantwortlich für den Versicherungsschutz der Teilnehmer.
                </p>

                <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3 text-dark-900">6.2</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                  Jeder Kunde trägt während und außerhalb der Coaching-Sitzungen die volle Verantwortung für sich selbst und seine Handlungen. Er haftet selbst für eventuell verursachte Schäden.
                </p>
              </div>

              <div className="bg-white border border-gray-200 rounded-xl sm:rounded-2xl p-4 sm:p-6 lg:p-8 mb-6 sm:mb-8">
                <h2 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4 text-dark-900">7. Haftungsausschluss</h2>
                
                <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3 text-dark-900">7.1</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3 sm:mb-4">
                  Die Tätigkeit von Alphavita – Coaching ist eine reine Dienstleistungstätigkeit. Ein Erfolg kann daher nicht garantiert oder geschuldet werden.
                </p>

                <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3 text-dark-900">7.2</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3 sm:mb-4">
                  Die von Alphavita – Coaching bereitgestellten Informationen, Ratschläge und Empfehlungen wurden sorgfältig geprüft. Jegliche Haftung für Schäden, die aus der Anwendung dieser Informationen entstehen, wird ausgeschlossen.
                </p>

                <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3 text-dark-900">7.3</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                  Die Haftung von Alphavita – Coaching ist auf grobe Fahrlässigkeit oder Vorsatz beschränkt.
                </p>
              </div>

              <div className="bg-white border border-gray-200 rounded-xl sm:rounded-2xl p-4 sm:p-6 lg:p-8 mb-6 sm:mb-8">
                <h2 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4 text-dark-900">8. Vertraulichkeit und Datenschutz</h2>
                
                <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3 text-dark-900">8.1</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3 sm:mb-4">
                  Alfira Herrmann (Alphavita – Coaching) verpflichtet sich, über alle im Rahmen der Tätigkeit bekannt gewordenen betrieblichen, geschäftlichen und privaten Angelegenheiten des Kunden Stillschweigen zu bewahren, auch nach Beendigung des Vertrages.
                </p>

                <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3 text-dark-900">8.2</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3 sm:mb-4">
                  Die zur Durchführung der Dienstleistung überlassenen Unterlagen und Aufzeichnungen werden sorgfältig verwahrt und vor dem Zugriff Dritter geschützt.
                </p>

                <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3 text-dark-900">8.3</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                  Weitere Informationen zum Datenschutz, insbesondere zu den Rechten des Kunden nach der Datenschutz-Grundverordnung (DSGVO), finden sich in der separaten Datenschutzerklärung auf der Website.
                </p>
              </div>

              <div className="bg-white border border-gray-200 rounded-xl sm:rounded-2xl p-4 sm:p-6 lg:p-8 mb-6 sm:mb-8">
                <h2 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4 text-dark-900">9. Mitwirkungspflicht des Kunden</h2>
                
                <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3 text-dark-900">9.1</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3 sm:mb-4">
                  Die Zusammenarbeit basiert auf gegenseitigem Vertrauen. Coaching ist ein freiwilliger, aktiver und eigenverantwortlicher Prozess.
                </p>

                <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3 text-dark-900">9.2</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3 sm:mb-4">
                  Der Kunde ist sich bewusst, dass Alphavita – Coaching als Prozessbegleiterin und Unterstützung dient, die tatsächliche Veränderungsarbeit jedoch vom Kunden selbst geleistet werden muss.
                </p>

                <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3 text-dark-900">9.3</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                  Voraussetzung für eine erfolgreiche Zusammenarbeit ist die Offenheit und die Bereitschaft des Kunden, sich aktiv mit seiner Situation auseinanderzusetzen.
                </p>
              </div>

              <div className="bg-white border border-gray-200 rounded-xl sm:rounded-2xl p-4 sm:p-6 lg:p-8 mb-6 sm:mb-8">
                <h2 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4 text-dark-900">10. Abgrenzung zur Psychotherapie und Heilkunde</h2>
                
                <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3 text-dark-900">10.1</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3 sm:mb-4">
                  Coaching ist keine Therapie und ersetzt diese auch nicht. Die Tätigkeit von Alphavita – Coaching grenzt sich klar von der Rolle eines Arztes, Psychologen oder Heilpraktikers ab.
                </p>

                <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3 text-dark-900">10.2</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3 sm:mb-4">
                  Es werden keine Diagnosen gestellt oder Heilversprechen abgegeben.
                </p>

                <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3 text-dark-900">10.3</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3 sm:mb-4">
                  Ein Coaching bei Alphavita – Coaching setzt eine normale psychische und physische Belastbarkeit des Kunden voraus. Mit der Einwilligung zur Zusammenarbeit bestätigt der Kunde seine Fähigkeit zur Selbstreflexion und Handlungsfähigkeit.
                </p>

                <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3 text-dark-900">10.4</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                  Der Kunde ist verpflichtet, Alphavita – Coaching über eventuelle Vorerkrankungen, Diagnosen oder laufende psychotherapeutische Verfahren zu informieren.
                </p>
              </div>

              <div className="bg-white border border-gray-200 rounded-xl sm:rounded-2xl p-4 sm:p-6 lg:p-8 mb-6 sm:mb-8">
                <h2 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4 text-dark-900">11. Schlussbestimmungen</h2>
                
                <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3 text-dark-900">11.1</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3 sm:mb-4">
                  Sollten einzelne Bestimmungen dieser AGB ganz oder teilweise unwirksam sein, so bleibt die Wirksamkeit der übrigen Bestimmungen davon unberührt. Anstelle der unwirksamen Bestimmung gelten die einschlägigen gesetzlichen Vorschriften.
                </p>

                <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3 text-dark-900">11.2</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                  Erfüllungsort ist Emmendingen. Gerichtsstand für alle Streitigkeiten aus diesem Vertrag ist das zuständige Gericht in Emmendingen. Es gilt das Recht der Bundesrepublik Deutschland.
                </p>
              </div>

              <div className="bg-rose-50 border border-rose-200 rounded-xl sm:rounded-2xl p-4 sm:p-6 lg:p-8">
                <p className="text-sm sm:text-base text-gray-600 text-center">
                  <strong>Emmendingen, 22.09.2025</strong>
                </p>
              </div>
            </motion.div>
          </div>
        </motion.section>
      </main>
      <Footer />
    </div>
  );
}
